import _ from 'lodash';
import ApiService from '~/utils/ApiService';
import * as MODEL from '~/constants/ModelConstants';
import { browserHistory } from 'react-router';
import Helpers from '~/utils/Helpers';
import ErrorService from '~/utils/ErrorService';
import SafeVersionService from '~/artifact/utils/SafeVersionService';
import PermissionsHelper from '~/utils/PermissionsHelper';
import ArtifactHelper from '~/utils/ArtifactHelper';

export const GET_ARTIFACT = 'GET_ARTIFACT';

export const UPDATE_ARTIFACT_ACTIVE_URL = 'UPDATE_ARTIFACT_ACTIVE_URL';
export const UPDATE_ARTIFACT_VIEW_MODE = 'UPDATE_ARTIFACT_VIEW_MODE';
export const UPDATE_ARTIFACT_ACTIVE_TAB = 'UPDATE_ARTIFACT_ACTIVE_TAB';
export const UPDATE_ARTIFACT_ACTIVE_ARTIFACT = 'UPDATE_ARTIFACT_ACTIVE_ARTIFACT';
export const UPDATE_ARTIFACT_EDITS = 'UPDATE_ARTIFACT_EDITS';

export const REQUEST_COMPONENTS = 'REQUEST_COMPONENTS';
export const RECEIVE_COMPONENTS = 'RECEIVE_COMPONENTS';

export const RECEIVE_SUBMITTED_ARTIFACT = 'RECEIVE_SUBMITTED_ARTIFACT';
export const SUBMIT_ARTIFACT_EDITS = 'SUBMIT_ARTIFACT_EDITS';

export const ENABLE_ADDING_COMPONENT = 'ENABLE_ADDING_COMPONENT';
export const DISABLE_ADDING_COMPONENT = 'DISABLE_ADDING_COMPONENT';
export const TOGGLE_ADDING_COMPONENT = 'TOGGLE_ADDING_COMPONENT';

export const LOAD_EDITED_ARTIFACT = 'LOAD_EDITED_ARTIFACT';
export const UPDATE_EDITED_ARTIFACT = 'UPDATE_EDITED_ARTIFACT';

export const UPDATE_ARTIFACT_CURRENTLY_EDITING = 'UPDATE_ARTIFACT_CURRENTLY_EDITING';
export const UPDATE_ARTIFACT_COMPONENT_BEFORE_EDITING = 'UPDATE_ARTIFACT_COMPONENT_BEFORE_EDITING';
export const UPDATE_RANGE_BEFORE_EDITING = 'UPDATE_RANGE_BEFORE_EDITING';
export const UPDATE_ARTIFACT_FIX_LINK_BEFORE_EDITING = 'UPDATE_ARTIFACT_FIX_LINK_BEFORE_EDITING';
export const UPDATE_COMPONENT_BEFORE_EDITS = 'UPDATE_COMPONENT_BEFORE_EDITS';
export const UPDATE_ARTIFACT_RANGE_BEFORE_EDITING = 'UPDATE_ARTIFACT_RANGE_BEFORE_EDITING';
export const UPDATE_ARTIFACT_COMPONENTS = 'UPDATE_ARTIFACT_COMPONENTS';

export const FINISH_EDIT_FIX_LINK = 'FINISH_EDIT_FIX_LINK';

export const REQUEST_COMPONENT_NAME_MATCHES = 'REQUEST_COMPONENT_NAME_MATCHES';
export const RECEIVE_COMPONENT_NAME_MATCHES = 'RECEIVE_COMPONENT_NAME_MATCHES';
export const ADD_COMPONENT = 'ADD_COMPONENT';
export const RESET_ADDING_COMPONENT = 'RESET_ADDING_COMPONENT';

export const UPDATE_ARTIFACT_LINK_BEFORE_EDITING = 'UPDATE_ARTIFACT_LINK_BEFORE_EDITING';

export const UPDATE_ARTIFACT_CURRENTLY_VIEWING = 'UPDATE_ARTIFACT_CURRENTLY_VIEWING';
export const RESET_MARKDOWN_HTML = 'RESET_MARKDOWN_HTML';
export const REQUEST_MARKDOWN_HTML = 'REQUEST_MARKDOWN_HTML';
export const RECEIVE_MARKDOWN_HTML = 'RECEIVE_MARKDOWN_HTML';
export const REQUEST_VULNERABLE_COMPONENT_VERSIONS = 'REQUEST_VULNERABLE_COMPONENT_VERSIONS';
export const RECEIVE_VULNERABLE_COMPONENT_VERSIONS = 'RECEIVE_VULNERABLE_COMPONENT_VERSIONS';
export const RECEIVE_VULN_METHOD_ANALYSIS = 'RECEIVE_VULN_METHOD_ANALYSIS';

export const UPDATE_EXPLOIT_BEFORE_EDITING = 'UPDATE_EXPLOIT_BEFORE_EDITING';

export const UPDATE_RISK_BREAKDOWN_SECTION = 'UPDATE_RISK_BREAKDOWN_SECTION';
export const UPDATE_COMPONENT_ID = 'UPDATE_COMPONENT_ID';
export const UPDATE_COMPONENT_VERSION = 'UPDATE_COMPONENT_VERSION';
export const UPDATE_IS_DISPLAY_VULNERABLE_VERSIONS = 'UPDATE_IS_DISPLAY_VULNERABLE_VERSIONS';
export const UPDATE_SIGNATURE_SECTION = 'UPDATE_SIGNATURE_SECTION';
export const UPDATE_COMPONENT_PACKAGE_MANAGER = 'UPDATE_COMPONENT_PACKAGE_MANAGER';
export const UPDATE_VULNERABLE_RANGE_BY_COMPONENT = 'UPDATE_VULNERABLE_RANGE_BY_COMPONENT';
export const UPDATE_IS_RANGE_SELECT_FOCUSED = 'UPDATE_IS_RANGE_SELECT_FOCUSED';
export const UPDATE_FIX_SECTION = 'UPDATE_FIX_SECTION';
export const UPDATE_EXPLOIT_ID = 'UPDATE_EXPLOIT_ID';
export const UPDATE_EXPLOIT_SECTION = 'UPDATE_EXPLOIT_SECTION';
export const UPDATE_VULNERABLE_METHODS = 'UPDATE_VULNERABLE_METHODS';

export const UPDATE_VULNERABLE_VERSION = 'UPDATE_VULNERABLE_VERSION';

export const UPDATE_IS_VALIDATING = 'UPDATE_IS_VALIDATING';
export const UPDATE_IS_ANALYZING = 'UPDATE_IS_ANALYZING';
export const UPDATE_IS_APPLYING = 'UPDATE_IS_APPLYING';
export const UPDATE_ANALYZING_ERROR = 'UPDATE_ANALYZING_ERROR';
export const UPDATE_VALIDATING_ERROR = 'UPDATE_VALIDATING_ERROR';
export const UPDATE_VULNERABLE_METHOD_TO_ANALYZE = 'UPDATE_VULNERABLE_METHOD_TO_ANALYZE';
export const UPDATE_VALIDATED_METHOD = 'UPDATE_VALIDATED_METHOD';

export const UPDATE_RANGE_SELECT_FOCUS = 'UPDATE_RANGE_SELECT_FOCUS';

export const POPULATE_REFERENCE_FILTERS = 'POPULATE_REFERENCE_FILTERS';
export const TOGGLE_REFERENCE_FILTER = 'TOGGLE_REFERENCE_FILTER';
export const TOGGLE_REFERENCE_DROPDOWN = 'TOGGLE_REFERENCE_DROPDOWN';

export const UPDATE_IS_SUBMITTING_ARTIFACT = 'UPDATE_IS_SUBMITTING_ARTIFACT';

export const UPDATE_RECENT_VULNS = 'UPDATE_RECENT_VULNS';

export const REQUEST_SAFE_VERSIONS_AFTER_RANGE = 'REQUEST_SAFE_VERSIONS_AFTER_RANGE';
export const RECEIVE_SAFE_VERSIONS_AFTER_RANGE = 'RECEIVE_SAFE_VERSIONS_AFTER_RANGE';
export const RESET_SAFE_VERSIONS_AFTER_RANGE = 'RESET_SAFE_VERSIONS_AFTER_RANGE';
export const UPDATE_ACTIVE_SAFE_VERSION = 'UPDATE_ACTIVE_SAFE_VERSION';

export const REQUEST_EXPLOITS = 'REQUEST_EXPLOITS';
export const RECEIVE_EXPLOITS_SUCCESS = 'RECEIVE_EXPLOITS_SUCCESS';
export const RECEIVE_EXPLOITS_ERROR = 'RECEIVE_EXPLOITS_ERROR';

export const UPDATE_FE_VALIDATION = 'UPDATE_FE_VALIDATION';

export const UPDATE_EXPLOT_FILE_URL = 'UPDATE_EXPLOT_FILE_URL';

export const UPDATE_ACTIVE_VULN_RANGE_TAB = 'UPDATE_ACTIVE_VULN_RANGE_TAB';

export const FETCH_COMMIT_HASH_FIX_INFO_SUCCESS = 'FETCH_COMMIT_HASH_FIX_INFO_SUCCESS';
export const FETCH_COMMIT_HASH_FIX_INFO_REQUEST = 'FETCH_COMMIT_HASH_FIX_INFO_REQUEST';
export const FETCH_COMMIT_HASH_FIX_INFO_ERROR = 'FETCH_COMMIT_HASH_FIX_INFO_ERROR';

export const UPDATE_ARTIFACT_ACTIVE_COMMIT_HASH = 'UPDATE_ARTIFACT_ACTIVE_UPDATE_COMMIT_HASH';
export const UPDATE_ACTIVE_SAFE_COMMIT_HASH = 'UPDATE_ACTIVE_SAFE_COMMIT_HASH';

export const CHECK_COMPONENT_HEAD_SAFE_REQUEST = 'CHECK_COMPONENT_HEAD_SAFE_REQUEST';
export const CHECK_COMPONENT_HEAD_SAFE_SUCCESS = 'CHECK_COMPONENT_HEAD_SAFE_SUCCESS';
export const CHECK_COMPONENT_HEAD_SAFE_FAILURE = 'CHECK_COMPONENT_HEAD_SAFE_FAILURE';

export const UPDATE_ARTIFACT_EXPLOITABILITY = 'UPDATE_ARTIFACT_EXPLOITABILITY';

/////////////////
// Actions
/////////////////

export const updateArtifact = artifact => {
  return {
    type: GET_ARTIFACT,
    artifact,
  };
};

export const updateActiveSafeVersion = version => {
  return {
    type: UPDATE_ACTIVE_SAFE_VERSION,
    version,
    meta: {
      snowplow: true,
      string1: version,
    },
  };
};

export const requestSafeVersionsAfterRange = () => {
  return {
    type: REQUEST_SAFE_VERSIONS_AFTER_RANGE,
  };
};
export const receiveSafeVersionsAfterRange = versions => {
  return {
    type: RECEIVE_SAFE_VERSIONS_AFTER_RANGE,
    versions,
  };
};
export const resetSafeVersionsAfterRange = () => {
  return {
    type: RESET_SAFE_VERSIONS_AFTER_RANGE,
  };
};

export const fetchSafeVersionsAfterRange = (id, range, setCalculatedActiveSafeVersion = true) => {
  return function(dispatch, getState) {
    dispatch(requestSafeVersionsAfterRange());

    const { artifact } = getState().artifactState;

    if (
      ArtifactHelper.isArtifactPremium(artifact) &&
      !PermissionsHelper.isOrgPaidOrTrial(getState())
    ) {
      return;
    }

    ApiService.get('/catalog/components/' + id + '/versions?filter=safe&after-range=' + range, {
      shouldUseVeracodeApi: Helpers.isVeracodeUser(getState()),
    })
      .then(res => {
        //should be the version objects
        dispatch(receiveSafeVersionsAfterRange(res));
        if (res.length > 0) {
          //Use calculated safe version as default activeSafeVersion, otherwise set to the first on the list.
          if (setCalculatedActiveSafeVersion) {
            const fixVersion = range.updateToVersion;
            const safeVersions = res || [];
            const calculatedSafeVersion = SafeVersionService.findSafeVersion(
              safeVersions,
              fixVersion
            );

            dispatch(updateActiveSafeVersion(calculatedSafeVersion));
          } else {
            dispatch(updateActiveSafeVersion(res[0].version));
          }
        }
      })
      .catch(() => {
        // maybe you want to do more error handling; this setup will just act the same as if
        // there are no safe versions`
        dispatch(receiveSafeVersionsAfterRange([]));
      });
  };
};

export const toggleReferenceDropdown = () => {
  return {
    type: TOGGLE_REFERENCE_DROPDOWN,
  };
};

export const toggleReferenceFilter = filter => {
  return {
    type: TOGGLE_REFERENCE_FILTER,
    filter,
  };
};

export const populateReferenceFilters = referenceFilters => {
  return {
    type: POPULATE_REFERENCE_FILTERS,
    referenceFilters,
  };
};

export const updateRangeSelectFocus = bool => {
  return {
    type: UPDATE_RANGE_SELECT_FOCUS,
    bool,
  };
};

export const updateRiskBreakdownSection = section => {
  return {
    type: UPDATE_RISK_BREAKDOWN_SECTION,
    section,
    meta: {
      snowplow: true,
      string1: section,
    },
  };
};

export const updateComponentId = id => {
  return {
    type: UPDATE_COMPONENT_ID,
    id,
    meta: {
      snowplow: true,
      integer1: id,
    },
  };
};

export const updateIsDisplayVulnerableVersions = bool => {
  return {
    type: UPDATE_IS_DISPLAY_VULNERABLE_VERSIONS,
    bool,
  };
};

export const updateSignatureSection = section => {
  return {
    type: UPDATE_SIGNATURE_SECTION,
    section,
    meta: {
      snowplow: true,
      string1: section,
    },
  };
};

export const updateComponentPackageManager = (manager, section) => {
  manager = manager.toLowerCase();
  return {
    type: UPDATE_COMPONENT_PACKAGE_MANAGER,
    manager,
    section,
  };
};

export const updateFixSection = section => {
  return {
    type: UPDATE_FIX_SECTION,
    section,
    meta: {
      snowplow: true,
      string1: section,
    },
  };
};

export const updateExploitId = id => {
  return {
    type: UPDATE_EXPLOIT_ID,
    id,
  };
};

export const updateExploitSection = section => {
  return {
    type: UPDATE_EXPLOIT_SECTION,
    section,
    meta: {
      snowplow: true,
      string1: section,
    },
  };
};

export const updateComponentVersion = version => {
  return {
    type: UPDATE_COMPONENT_VERSION,
    version,
    meta: {
      snowplow: true,
      string1: version,
    },
  };
};

export const updateVulnerableVersion = version => ({
  type: UPDATE_VULNERABLE_VERSION,
  version,
  meta: {
    snowplow: true,
    string1: version,
  },
});

export const updateVulnerableRangeByComponent = (range, componentId = null) => {
  return {
    type: UPDATE_VULNERABLE_RANGE_BY_COMPONENT,
    range: range,
    componentId: componentId,
  };
};

export const updateActiveVulnRangeTab = tab => {
  return {
    type: UPDATE_ACTIVE_VULN_RANGE_TAB,
    tab,
  };
};

export const updateArtifactActiveUrl = url => {
  return {
    type: UPDATE_ARTIFACT_ACTIVE_URL,
    url: url,
  };
};
export const updateArtifactViewMode = viewMode => {
  return {
    type: UPDATE_ARTIFACT_VIEW_MODE,
    viewMode: viewMode,
  };
};
export const updateArtifactActiveTab = tab => {
  return {
    type: UPDATE_ARTIFACT_ACTIVE_TAB,
    tab: tab,
  };
};
export const updateArtifactActiveArtifact = artifact => {
  return {
    type: UPDATE_ARTIFACT_ACTIVE_ARTIFACT,
    artifact: artifact,
  };
};
export const receiveComponents = affectedComponents => {
  return {
    type: RECEIVE_COMPONENTS,
    affectedComponents: affectedComponents,
  };
};
export const requestComponents = () => {
  return {
    type: REQUEST_COMPONENTS,
    isFetching: true,
  };
};
export const updateArtifactEdits = edits => {
  return {
    type: UPDATE_ARTIFACT_EDITS,
    field: edits.field,
    value: edits.value,
  };
};

export const enableAddingComponent = () => {
  return {
    type: ENABLE_ADDING_COMPONENT,
  };
};
export const toggleAddingComponent = () => {
  return {
    type: TOGGLE_ADDING_COMPONENT,
  };
};
export const disableAddingComponent = () => {
  return {
    type: DISABLE_ADDING_COMPONENT,
  };
};
export const updateArtifactCurrentlyEditing = currentlyEditing => {
  return {
    type: UPDATE_ARTIFACT_CURRENTLY_EDITING,
    currentlyEditing: currentlyEditing,
  };
};
export const updateArtifactCurrentlyViewing = currentlyViewing => {
  return {
    type: UPDATE_ARTIFACT_CURRENTLY_VIEWING,
    currentlyViewing: currentlyViewing,
  };
};

export const updateVulnerableMethods = vulnerableMethods => {
  return {
    type: UPDATE_VULNERABLE_METHODS,
    vulnerableMethods,
  };
};

export const updateComponentBeforeEdits = componentIndex => {
  return function(dispatch, getState) {
    const store = getState().artifactState;
    const artifactComponent = store.editedArtifact.artifactComponents[componentIndex];

    return {
      type: UPDATE_ARTIFACT_COMPONENT_BEFORE_EDITING,
      component: _.cloneDeep(artifactComponent),
    };
  };
};

export const updateExploitBeforeEditing = exploit => {
  return {
    type: UPDATE_EXPLOIT_BEFORE_EDITING,
    exploit: _.cloneDeep(exploit),
  };
};

export const updateArtifactLinkBeforeEdits = () => {
  return function(dispatch, getState) {
    const store = getState().artifactState;
    const artifactLinkIndex = store.currentlyEditing.artifactLinkIndex;
    const artifactLink = store.editedArtifact.artifactLinks[artifactLinkIndex];

    return {
      type: UPDATE_ARTIFACT_LINK_BEFORE_EDITING,
      artifactLink: _.cloneDeep(artifactLink),
    };
  };
};

export const updateRangeBeforeEdits = rangeIndex => {
  return function(dispatch, getState) {
    const store = getState().artifactState;
    const componentIndex = store.currentlyEditing.componentIndex;
    const artifactComponent = store.editedArtifact.artifactComponents[componentIndex];
    const range = artifactComponent.versionRanges[rangeIndex];

    return {
      type: UPDATE_ARTIFACT_RANGE_BEFORE_EDITING,
      range: _.cloneDeep(range),
    };
  };
};

export const updateFixLinkBeforeEdits = linkIndex => {
  return function(dispatch, getState) {
    const store = getState().artifactState;
    const { currentlyEditing } = store;
    const { componentIndex, rangeIndex } = currentlyEditing;
    const artifactComponent = store.editedArtifact.artifactComponents[componentIndex];
    const range = artifactComponent.versionRanges[rangeIndex];
    const fixLink = range.fixLinks[linkIndex];

    return {
      type: UPDATE_ARTIFACT_FIX_LINK_BEFORE_EDITING,
      fixLink: _.cloneDeep(fixLink),
    };
  };
};

export const requestVulnerableComponentVersions = () => ({
  type: REQUEST_VULNERABLE_COMPONENT_VERSIONS,
});

export const receiveVulnerableComponentVersions = (componentId, vulnerableVersions) => {
  return {
    type: RECEIVE_VULNERABLE_COMPONENT_VERSIONS,
    id: componentId,
    vulnerableVersions: vulnerableVersions,
  };
};

export const submittingArtifactEdits = () => {
  return {
    type: SUBMIT_ARTIFACT_EDITS,
  };
};
export const receiveSubmittedArtifact = artifact => {
  return {
    type: RECEIVE_SUBMITTED_ARTIFACT,
    artifact: artifact,
    isSubmittingArtifact: false,
  };
};
export const updateIsSubmittingArtifact = bool => {
  return {
    type: UPDATE_IS_SUBMITTING_ARTIFACT,
    bool,
  };
};
export const loadEditedArtifact = editedArtifact => {
  return {
    type: LOAD_EDITED_ARTIFACT,
    editedArtifact: editedArtifact,
  };
};
export const updateEditedArtifact = editObj => {
  return {
    type: UPDATE_EDITED_ARTIFACT,
    field: editObj.field,
    value: editObj.value,
  };
};

export const resetAddingComponent = () => {
  return {
    type: RESET_ADDING_COMPONENT,
  };
};

export const updateArtifactComponents = components => {
  return {
    type: UPDATE_ARTIFACT_COMPONENTS,
    components: components,
  };
};

export const requestComponentNameMatches = () => {
  return {
    type: REQUEST_COMPONENT_NAME_MATCHES,
    isFetchingComponentNameMatches: true,
    addingComponentNameMatches: [],
    isChoosingComponent: false,
  };
};

export const receiveComponentNameMatches = nameMatches => {
  return {
    type: RECEIVE_COMPONENT_NAME_MATCHES,
    addingComponentNameMatches: nameMatches,
    isFetchingComponentNameMatches: false,
    isChoosingComponent: nameMatches.length > 0,
  };
};

export const resetMarkdownHtml = field => {
  return {
    type: RESET_MARKDOWN_HTML,
    field: field,
  };
};

export const requestMarkdownHtml = field => {
  return {
    type: REQUEST_MARKDOWN_HTML,
    field,
  };
};

export const receiveMarkdownHtml = (field, html) => {
  return {
    type: RECEIVE_MARKDOWN_HTML,
    field: field,
    html: html,
  };
};

export const recieveVulnMetholdAnalyis = data => {
  return {
    type: RECEIVE_VULN_METHOD_ANALYSIS,
    vulnMethodAnalysisData: data,
  };
};

export const updateExplotFileUrl = fileUrl => {
  return {
    type: UPDATE_EXPLOT_FILE_URL,
    fileUrl,
  };
};

export const updateArtifactActiveCommitHash = commitHash => ({
  type: UPDATE_ARTIFACT_ACTIVE_COMMIT_HASH,
  commitHash,
});

export const fetchCommitHashFixInfoSuccess = (componentId, commitHash, fixInfo) => ({
  type: FETCH_COMMIT_HASH_FIX_INFO_SUCCESS,
  componentId,
  commitHash,
  fixInfo,
});

export const fetchCommitHashFixInfoRequest = () => ({
  type: FETCH_COMMIT_HASH_FIX_INFO_REQUEST,
});

export const fetchCommitHashFixInfoError = errorMessage => ({
  type: FETCH_COMMIT_HASH_FIX_INFO_ERROR,
  errorMessage,
});

export const updateActiveSafeCommitHash = activeSafeCommitHash => ({
  type: UPDATE_ACTIVE_SAFE_COMMIT_HASH,
  activeSafeCommitHash,
});

export const checkComponentHeadSafeRequest = () => ({
  type: CHECK_COMPONENT_HEAD_SAFE_REQUEST,
});

export const checkComponentHeadSafeSuccess = (componentId, res) => ({
  type: CHECK_COMPONENT_HEAD_SAFE_SUCCESS,
  componentId,
  res,
});

export const checkComponentHeadSafeFailure = error => ({
  type: CHECK_COMPONENT_HEAD_SAFE_REQUEST,
  message: error.message || 'Something went wrong',
});

export const updateArtifactExploitability = exploitability => ({
    type: UPDATE_ARTIFACT_EXPLOITABILITY,
    exploitability: exploitability
});


/////////////////
// Helper methods
/////////////////

export const isUserPremiumOrTrial = teamState => {
  let teams = teamState.teams || [];

  return _.some(teams, team => {
    let planType = team && team.license && team.license.planType;
    return planType === 'TRIAL' || planType === 'PRO' || planType === 'ENTERPRISE';
  });
};

export const canUserEdit = user => {
  if (!_.isEmpty(user)) {
    const roles = user.roles || [];
    if (roles.indexOf('SC_RD_ADMIN') > -1 || roles.indexOf('SC_RESEARCHER') > -1) {
      return true;
    }
  }
  return false;
};

export const maybeUpdateArtifactActiveUrl = currentLocation => {
  return function(dispatch, getState) {
    const { artifactState: state } = getState();
    const newUrl = stripUrlSubtab(currentLocation);
    const storeUrl = stripUrlSubtab(state.activeUrl);

    // if url is different AND is another artifact page, update active artifact url
    if (newUrl.indexOf('/security/') > -1 && newUrl !== storeUrl) {
      dispatch(updateArtifactActiveUrl(newUrl));
    }
  };
};

export const stripUrlSubtab = url => {
  if (!url) {
    return '';
  }

  url = url.replace(/\/$/, '');
  const urlParts = url.split('/');
  const maybeSubtab = _.last(urlParts);
  const subtabs = Object.keys(MODEL.artifactViewSubtabs);
  const hasSubtab = _.indexOf(subtabs, maybeSubtab) > -1;

  if (hasSubtab) {
    return _.dropRight(urlParts).join('/');
  } else {
    return url;
  }
};

export const finishEditFixLink = fixLink => {
  return function(dispatch, getState) {
    const { artifactState: store } = getState();
    const { editedArtifact } = store;
    const artifactComponents = Object.assign([], editedArtifact.artifactComponents);
    const component = artifactComponents[store.currentlyEditing.componentIndex];
    const { versionRanges: ranges } = component;
    const range = ranges[store.currentlyEditing.rangeIndex];

    range.fixLinks[store.currentlyEditing.fixLinkIndex] = fixLink;

    dispatch(updateEditedArtifact({ field: 'artifactComponents', value: artifactComponents }));
    dispatch(updateArtifactCurrentlyEditing({ fixLinkIndex: null }));
    dispatch(updateFixLinkBeforeEdits(null));
  };
};

export const finishEditVersionRange = versionRange => {
  return function(dispatch, getState) {
    const { artifactState: store } = getState();
    const { editedArtifact } = store;
    const artifactComponents = Object.assign([], editedArtifact.artifactComponents);
    const component = artifactComponents[store.currentlyEditing.componentIndex];
    const { versionRanges: ranges } = component;

    ranges[store.currentlyEditing.rangeIndex] = versionRange;

    dispatch(updateEditedArtifact({ field: 'artifactComponents', value: artifactComponents }));
    dispatch(updateArtifactCurrentlyEditing({ rangeIndex: null, fixLinkIndex: null }));
    dispatch(updateRangeBeforeEdits(null));
  };
};

export const finishEditExploit = exploitWithEdits => {
  return function(dispatch, getState) {
    const { artifactState: store } = getState();
    const { editedArtifact } = store;
    const exploits = Object.assign([], editedArtifact.exploits);
    let newExploits;

    newExploits = exploits.map(exploit => {
      if (exploit.id === exploitWithEdits.id) {
        return exploitWithEdits;
      } else {
        return exploit;
      }
    });

    dispatch(updateEditedArtifact({ field: 'exploits', value: newExploits }));
    dispatch(updateArtifactCurrentlyEditing({ exploitId: null }));
    dispatch(updateExploitBeforeEditing(null));
  };
};

export const deleteExploitFile = (exploitId, sha) => {
  return function(dispatch, getState) {
    const { artifactState: store } = getState();
    const { artifact } = store;
    const baseUrl = artifact.links.self.split('?')[0];
    const endpoint = baseUrl + '/exploits/' + exploitId + '/files/' + sha;

    ApiService.delete(endpoint)
      .then(function() {
        // console.log(res);
      })
      .catch(function() {
        // console.log(err);
      });
  };
};

export const uploadExploitFile = (exploitId, files) => {
  return function(dispatch, getState) {
    const store = getState().artifactState;
    const { editedArtifact } = store;
    const baseUrl = editedArtifact.links.self.split('?')[0];
    const endpoint = baseUrl + '/exploits/' + exploitId + '/files';
    const exploits = Object.assign([], editedArtifact.exploits);
    const exploit =
      _.find(exploits, exploit => {
        return exploit.id === exploitId;
      }) || {};
    const formdata = new FormData();

    files.forEach(function(file) {
      formdata.append('file', file);
    });

    ApiService.post(endpoint, { data: formdata, headers: { 'Content-Type': undefined } })
      .then(function(data) {
        exploit.exploits.push(data);
        dispatch(
          updateEditedArtifact({
            field: 'exploits',
            value: exploits,
          })
        );
      })
      .catch(function() {
        // console.log(err);
      });
  };
};

export const deleteExploit = exploitIdToDelete => {
  return function(dispatch, getState) {
    const store = getState().artifactState;
    const { editedArtifact, artifact } = store;
    const baseUrl = artifact.links.self.split('?')[0];
    const exploits = _.cloneDeep(editedArtifact.exploits);
    const exploitToDelete = _.find(exploits, exploit => {
      return exploit.id === exploitIdToDelete;
    });
    const endpoint = baseUrl + '/exploits/' + exploitIdToDelete;

    ApiService.delete(endpoint)
      .then(function() {
        dispatch(fetchExploits());
        // console.log(res);
      })
      .catch(function() {
        // console.log(err);
      });

    exploitToDelete.isDeleted = true;

    dispatch(
      updateEditedArtifact({
        field: 'exploits',
        value: exploits,
      })
    );
  };
};

export const deleteArtifactLink = linkIndexToDelete => {
  return function(dispatch, getState) {
    const { artifactState: store } = getState();
    const { editedArtifact } = store;
    const artifactLinks = _.cloneDeep(editedArtifact.artifactLinks);

    artifactLinks[linkIndexToDelete].isDeleted = true;

    dispatch(
      updateEditedArtifact({
        field: 'artifactLinks',
        value: artifactLinks,
      })
    );
  };
};

export const finishEditArtifactLink = link => {
  return function(dispatch, getState) {
    const { artifactState: store } = getState();
    const { editedArtifact } = store;
    const artifactLinks = Object.assign([], editedArtifact.artifactLinks);

    artifactLinks[store.currentlyEditing.artifactLinkIndex] = link;

    dispatch(updateEditedArtifact({ field: 'artifactLinks', value: artifactLinks }));
    dispatch(updateArtifactCurrentlyEditing({ artifactLinkIndex: null }));
    dispatch(updateArtifactLinkBeforeEdits(null));
  };
};

export const fetchComponents = components => {
  return function(dispatch, getState) {
    let endpoint,
      componentPromise,
      componentsWithFilteredRanges = [];

    dispatch(requestComponents());
    components.forEach(function(component) {
      endpoint = '/catalog/components/' + component.componentId;
      componentPromise = ApiService.get(endpoint, {
        shouldUseVeracodeApi: Helpers.isVeracodeUser(getState()),
      });
      componentsWithFilteredRanges.push(componentPromise);
    });

    Promise.all(componentsWithFilteredRanges).then(function(res) {
      dispatch(receiveComponents(res));
    });
  };
};

export const fetchVulnerableMethodsWithRange = (artifact, artifactComponentId, rangeId) => {
  return function(dispatch) {
    let endpoint = artifact.links.self.split('?')[0];

    endpoint += '/components/' + artifactComponentId + '/ranges/' + rangeId + '/methods';
    ApiService.get(endpoint)
      .then(function(res) {
        dispatch(updateVulnerableMethods(res));

        //vulnerableMethods: [
        //  {
        //    "count": 3,
        //    "className": "org/apache/http/conn/ssl/AbstractVerifier",
        //    "methodName": "getCNs",
        //    "descriptor": "(Ljava/security/cert/X509Certificate;)"
        //  }
        //]
      })
      .catch(function() {
        dispatch(updateVulnerableMethods([]));
      });
  };
};

export const fetchVulnerableMethods = (artifact, artifactComponentId, version) => {
  return function(dispatch, getState) {
    let endpoint = artifact.links.self.split('?')[0];

    endpoint += '/components/' + artifactComponentId + '/methods?version=' + version;

    if (!PermissionsHelper.isOrgPaidOrTrial(getState())) {
      dispatch(updateVulnerableMethods([]));
      return;
    }

    ApiService.get(endpoint)
      .then(function(res) {
        dispatch(updateVulnerableMethods(res));

        //vulnerableMethods: [
        //  {
        //    "count": 3,
        //    "className": "org/apache/http/conn/ssl/AbstractVerifier",
        //    "methodName": "getCNs",
        //    "descriptor": "(Ljava/security/cert/X509Certificate;)"
        //  }
        //]
      })
      .catch(function() {
        dispatch(updateVulnerableMethods([]));
      });
  };
};

export const fetchVulnerableMethodAnalysis = (artifact, artifactComponentId, rangeId) => {
  return function(dispatch) {
    let endpoint = artifact.links.self.split('?')[0];

    endpoint += '/components/' + artifactComponentId + '/ranges/' + rangeId + '/method-analysis';
    ApiService.get(endpoint)
      .then(function(res) {
        dispatch(recieveVulnMetholdAnalyis(res));
      })
      .catch(function() {
        // console.log(err);
      });
  };
};

export const fetchVulnerableComponentVersions = (id, attempts = 0) => {
  return function(dispatch, getState) {
    const { artifactState: store } = getState();
    const { artifact } = store;
    const affectedComponent =
      store.affectedComponents.find(function(component) {
        return component.id === id;
      }) || {};
    const artifactComponents = artifact.artifactComponents || [];
    const artifactComponent =
      _.find(artifactComponents, function(component) {
        return component.componentId === id;
      }) || {};
    const versionRangeObjects = artifactComponent.versionRanges || [];
    const versionRanges =
      versionRangeObjects.map(function(range) {
        return range.versionRange
          .split(',')
          .map(function(rangeItem) {
            return rangeItem.trim();
          })
          .join(',');
      }) || []; // end result eliminates spaces: '1.2-1.3, 1.4-1.5,  1.6-1.7'   ==>   '1.2-1.3,1.4-1.5,1.6-1.7'
    const rangeQuery = versionRanges.join(',') || '';
    const endpoint =
      affectedComponent && affectedComponent.links
        ? affectedComponent.links.self + '?range=' + rangeQuery
        : '';

    if (store.activeTab === 'fix') {
      return;
    }

    if (rangeQuery && endpoint) {
      dispatch(requestVulnerableComponentVersions());

      ApiService.get(endpoint)
        .then(function(res) {
          const { versions } = res;
          dispatch(receiveVulnerableComponentVersions(id, versions));
          if (versions[0]) {
            dispatch(updateVulnerableVersion(versions[0].version));
          }
        })
        .catch(function() {
          // console.log(err);
        });
    } else if (attempts < 5) {
      setTimeout(function() {
        dispatch(fetchVulnerableComponentVersions(id, attempts++));
      }, 500);
    }
  };
};

export const checkIfComponentHeadSafe = componentId => dispatch => {
  dispatch(checkComponentHeadSafeRequest());

  return ApiService.get(
    `/catalog/components/${componentId}/commits:checkHashOrHeadIsSafe?hashOrHead=HEAD`
  )
    .then(res => {
      dispatch(checkComponentHeadSafeSuccess(componentId, res));
    })
    .catch(err => {
      ErrorService.capture('Unable to check if component head safe:', err);
      dispatch(checkComponentHeadSafeFailure(err));
    });
};

export const maybeFetchCommitHashFixInfo = (componentId, commitHashOrHead) => {
  return function(dispatch, getState) {
    const endpoint = `catalog/components/${componentId}/commits:checkHashOrHeadIsSafe?hashOrHead=${commitHashOrHead}`;

    dispatch(fetchCommitHashFixInfoRequest());
    ApiService.get(endpoint)
      .then(function(res) {
        if (res) {
          const { hasVulns, commitHash } = res;

          if (!hasVulns) {
            dispatch(updateActiveSafeCommitHash(commitHash));
          }
        }
        dispatch(fetchCommitHashFixInfoSuccess(componentId, commitHashOrHead, res));
      })
      .catch(err => {
        let userMessage;
        if (err && err.status !== 500 && err.hasOwnProperty('message')) {
          userMessage = err.message;
        } else {
          userMessage = '';
        }
        dispatch(updateActiveSafeCommitHash(''));
        dispatch(fetchCommitHashFixInfoError(userMessage));
      });
  };
};

export const deleteFixLink = linkIndexToDelete => {
  return function(dispatch, getState) {
    const store = getState().artifactState;
    const { editedArtifact } = store;
    const components = _.cloneDeep(editedArtifact.artifactComponents);
    const currentlyEditingComponentIndex = store.currentlyEditing.componentIndex;
    const component = components[currentlyEditingComponentIndex];
    const currentlyEditingRangeIndex = store.currentlyEditing.rangeIndex;
    const range = component.versionRanges[currentlyEditingRangeIndex];

    range.fixLinks[linkIndexToDelete].isDeleted = true;

    dispatch(
      updateEditedArtifact({
        field: 'artifactComponents',
        value: components,
      })
    );
  };
};
export const deleteVersionRange = rangeIndexToDelete => {
  return function(dispatch, getState) {
    const store = getState().artifactState;
    const { editedArtifact } = store;
    const components = _.cloneDeep(editedArtifact.artifactComponents);
    const currentlyEditingComponentIndex = store.currentlyEditing.componentIndex;
    const component = components[currentlyEditingComponentIndex];
    const ranges = component.versionRanges;

    ranges[rangeIndexToDelete].isDeleted = true;

    dispatch(
      updateEditedArtifact({
        field: 'artifactComponents',
        value: components,
      })
    );
  };
};
export const deleteComponent = componentIndexToDelete => {
  return function(dispatch, getState) {
    const store = getState().artifactState;
    const { editedArtifact } = store;
    const components = _.cloneDeep(editedArtifact.artifactComponents);

    components[componentIndexToDelete].isDeleted = true;

    dispatch(
      updateEditedArtifact({
        field: 'artifactComponents',
        value: components,
      })
    );
  };
};

export const resetCurrentlyViewingPackageManager = languageType => {
  return function(dispatch) {
    const language = languageType.toLowerCase();
    let manager;

    if (language === 'js') {
      manager = 'npm';
    } else if (language === 'java') {
      manager = 'maven';
    } else if (language === 'ruby') {
      manager = 'gem';
    } else if (language === 'python') {
      manager = 'pypi';
    }

    if (manager) {
      dispatch(updateArtifactCurrentlyViewing({ signatureComponentPackageManager: manager }));
    }
  };
};

export const submitArtifactEdits = () => {
  return function(dispatch, getState) {
    const state = getState().artifactState;
    const { artifact: oldArtifact, editedArtifact } = state;
    const submittableEditedArtifact = buildSubmittableArtifact(Object.assign({}, editedArtifact));
    const { exploits = [] } = submittableEditedArtifact;

    dispatch(submittingArtifactEdits());

    try {
      exploits.forEach(exploit => {
        ApiService.put('/artifacts/components/' + editedArtifact.id + '/exploits/' + exploit.id, {
          data: exploit,
          shouldUseVeracodeApi: Helpers.isVeracodeUser(getState()),
        })
          .then(() => {})
          .catch(() => {});
      });
    } finally {
      ApiService.put(editedArtifact.links.self, {
        data: submittableEditedArtifact,
        shouldUseVeracodeApi: Helpers.isVeracodeUser(getState()),
      })
        .then(function(data) {
          dispatch(receiveSubmittedArtifact(data));
          dispatch(fetchExploits());
          if (data.artifactComponents.length !== oldArtifact.artifactComponents.length) {
            dispatch(fetchComponents(data.artifactComponents));
          }
        })
        .catch(function() {
          dispatch(updateIsSubmittingArtifact(false));
          // $log.error('something failed: ', error);
        });
    }
  };
};

export const buildSubmittableArtifact = artifact => {
  let submittableArtifact = _.cloneDeep(artifact),
    filteredArtifactComponents;

  filteredArtifactComponents = _.reject(submittableArtifact.artifactComponents, {
    isDeleted: true,
  }).map(function(component) {
    component.versionRanges = _.reject(component.versionRanges, { isDeleted: true }).map(function(
      versionRange
    ) {
      versionRange.fixLinks = _.reject(versionRange.fixLinks, { isDeleted: true });
      return versionRange;
    });
    component.versionRanges = _.reject(component.versionRanges, { versionRange: null });
    return component;
  });

  submittableArtifact.artifactComponents = filteredArtifactComponents;

  submittableArtifact.artifactLinks = submittableArtifact.artifactLinks.filter(function(
    artifactLink
  ) {
    return !artifactLink.isDeleted;
  });

  submittableArtifact.artifactLinks = _.reject(submittableArtifact.artifactLinks, {
    type: 'OTHER',
    title: '',
    url: '',
  });

  if (submittableArtifact.exploits && submittableArtifact.exploits.length) {
    submittableArtifact.exploits = submittableArtifact.exploits.filter(function(exploit) {
      return !exploit.isDeleted;
    });
  }

  return submittableArtifact;
};

export const fetchComponentNameMatches = query => {
  return function(dispatch) {
    dispatch(requestComponentNameMatches());

    const endpoint = '/catalog/search?query=type%3Acomponent%20' + encodeURIComponent(query);
    ApiService.get(endpoint)
      .then(function(data) {
        // var nameMatches = data.results.filter(function(result) {
        //   return (result.componentName.indexOf(query) > -1);
        // });
        // console.log(data);
        dispatch(receiveComponentNameMatches(data.results));
      })
      .catch(function() {
        // $log.error('component name matches error:', error);
        dispatch(receiveComponentNameMatches([]));
      });
  };
};

export const addComponent = componentId => {
  return function(dispatch, getState) {
    const id = componentId;
    const endpoint = '/catalog/components/' + id;
    const store = getState().artifactState;
    const { editedArtifact } = store;
    const artifactComponents = Object.assign([], editedArtifact.artifactComponents);
    let newArtifactComponent;

    ApiService.get(endpoint)
      .then(function(data) {
        newArtifactComponent = {
          componentId: data.id,
          coordOne: data.coordinate1,
          coordTwo: data.coordinate2,
          componentLatestRelease: data.latestRelease.version || 'n/a',
          componentCoordinateType: data.coordinateType,
          componentLanguageType: data.languageType,
          versionRanges: [],
        };
        artifactComponents.push(newArtifactComponent);

        dispatch(updateEditedArtifact({ field: 'artifactComponents', value: artifactComponents }));
        dispatch(resetAddingComponent());
      })
      .catch(function() {
        // console.log('error grabbing component');
      });
  };
};

export const fetchMarkdownHtml = (field, markdown) => {
  return function(dispatch, getState) {
    dispatch(resetMarkdownHtml(field));
    dispatch(requestMarkdownHtml(field));
    ApiService.post('/markdown', {
      data: { markdown: markdown },
      shouldUseVeracodeApi: Helpers.isVeracodeUser(getState()),
    })
      .then(function(data) {
        dispatch(receiveMarkdownHtml(field, data.html));
      })
      .catch(function() {
        // console.log(err);
      });
  };
};

export const addExploit = exploit => {
  return function(dispatch, getState) {
    const store = getState().artifactState;
    const { editedArtifact } = store;
    const baseUrl = editedArtifact.links.self.split('?')[0];
    const endpoint = baseUrl + '/exploits';
    const exploits = Object.assign([], editedArtifact.exploits);

    ApiService.post(endpoint, { data: exploit })
      .then(function(res) {
        const exploit = res;
        exploits.push(exploit);
        dispatch(
          updateEditedArtifact({
            field: 'exploits',
            value: exploits,
          })
        );

        dispatch(
          updateArtifactCurrentlyEditing({
            newExploit: {
              type: 'EXPLOIT',
              title: 'new exploit',
              running: ' ',
              requirements: ' ',
              description: ' ',
              technicalDetails: ' ',
              exploits: [],
            },
            exploitId: null,
          })
        );
      })

      .catch(function() {
        // console.log(err);
      });
  };
};

export const validateVulnerableMethod = vulnerableMethod => {
  return function(dispatch, getState) {
    const store = getState().artifactState;
    const {
      vulnMethodComponentId: componentId,
      vulnMethodRangeId: rangeId,
    } = store.currentlyEditing;
    const baseUrl = store.editedArtifact.links.self.split('?')[0];
    let endpoint, request;

    endpoint = baseUrl + '/components/' + componentId + '/ranges/' + rangeId + '/methods/validate';
    request = vulnerableMethod;

    // reset all validation-related data
    dispatch(updateIsValidating(true));
    dispatch(updateValidatingError(null));
    dispatch(updateVulnerableMethodToAnalyze(null));
    dispatch(updateValidatedMethod(null));

    ApiService.post(endpoint, { data: request })
      .then(function(data) {
        const validationResult = data && data.result;
        dispatch(updateIsValidating(false));
        // something went wrong
        if (validationResult.result === 'NOT_FOUND') {
          dispatch(updateValidatingError('Unable to find the requested method in library'));
        } else if (validationResult.result === 'MISSING_COMPONENT') {
          dispatch(updateValidatingError('Unable to download component binary for analysis'));
        } else if (validationResult.result === 'SCAN_ERROR') {
          dispatch(
            updateValidatingError(
              'Unknown error; please see engineering' + validationResult.message
            )
          );
          data.versions = ['1'];
        } else if (validationResult.message) {
          dispatch(updateValidatingError(validationResult.message));
        }

        // nothing went wrong. found and validated the method
        dispatch(updateVulnerableMethodToAnalyze(vulnerableMethod));
        dispatch(
          updateValidatedMethod({
            validatedVersion: data.validatedVersion,
            versions: data.versions,
            estimatedTime: data.time * data.versions.length,
          })
        );
      })
      .catch(function(err) {
        // something went wrong with the request
        dispatch(updateIsValidating(false));
        dispatch(updateValidatingError(err.message));
      });
  };
};

export const submitVulnerableMethod = isForced => {
  return function(dispatch, getState) {
    const store = getState().artifactState;
    const {
      editedArtifact,
      validatedMethod,
      vulnerableMethodToAnalyze: vulnerableMethod,
      currentlyEditing,
    } = store;
    const { vulnMethodComponentId: componentId, vulnMethodRangeId: rangeId } = currentlyEditing;
    const baseUrl = store.editedArtifact.links.self.split('?')[0];
    let endpoint, request;

    if (isForced) {
      dispatch(updateIsApplying(true));
    } else {
      dispatch(updateIsAnalyzing(true));
    }
    dispatch(updateAnalyzingError(null));

    endpoint = baseUrl + '/components/' + componentId + '/ranges/' + rangeId + '/methods/analyze';
    if (isForced) {
      endpoint += '?force=true';
    }
    request = {
      methodAnalysisId: 0,
      method: vulnerableMethod,
      versions: validatedMethod.versions,
    };

    ApiService.post(endpoint, { data: request })
      .then(function() {
        const newVersionRangeMethods = Object.assign({}, editedArtifact.versionRangeMethods);
        newVersionRangeMethods[rangeId] = true;

        dispatch(updateIsAnalyzing(false));
        dispatch(updateIsApplying(false));
        dispatch(
          updateArtifactCurrentlyEditing({
            versionRangeMethods: newVersionRangeMethods,
            vulnMethodComponentId: null,
            vulnMethodRangeId: null,
          })
        );
      })
      .catch(function(err) {
        dispatch(updateIsAnalyzing(false));
        dispatch(updateIsApplying(false));
        dispatch(updateAnalyzingError(err.statusText || 'unknown error'));
      });
  };
};

export const updateIsValidating = bool => {
  return {
    type: UPDATE_IS_VALIDATING,
    bool,
  };
};
export const updateIsAnalyzing = bool => {
  return {
    type: UPDATE_IS_ANALYZING,
    bool,
  };
};
export const updateIsApplying = bool => {
  return {
    type: UPDATE_IS_APPLYING,
    bool,
  };
};
export const updateAnalyzingError = error => {
  return {
    type: UPDATE_ANALYZING_ERROR,
    error,
  };
};
export const updateValidatingError = error => {
  return {
    type: UPDATE_VALIDATING_ERROR,
    error,
  };
};
export const updateVulnerableMethodToAnalyze = method => {
  return {
    type: UPDATE_VULNERABLE_METHOD_TO_ANALYZE,
    method,
  };
};
export const updateValidatedMethod = method => {
  return {
    type: UPDATE_VALIDATED_METHOD,
    method,
  };
};

export const requestExploits = () => {
  return {
    type: REQUEST_EXPLOITS,
  };
};

export const receiveExploitsSuccess = () => {
  return {
    type: RECEIVE_EXPLOITS_SUCCESS,
  };
};

export const receiveExploitsError = () => {
  return {
    type: RECEIVE_EXPLOITS_ERROR,
  };
};

export const fetchExploits = () => {
  return function(dispatch, getState) {
    dispatch(requestExploits());

    const { artifactState: store } = getState();
    const { artifact } = store;
    const newArtifact = Object.assign({}, artifact);
    const baseUrl = artifact.links.self.split('?')[0];
    const endpoint = baseUrl + '/exploits';

    newArtifact.exploits = [];
    dispatch(receiveExploitsSuccess());

    ApiService.get(endpoint)
      .then(function(data) {
        newArtifact.exploits = data;

        dispatch(updateArtifactActiveArtifact(newArtifact));
        dispatch(updateEditedArtifact({ field: 'exploits', value: data }));
        if (data.length) {
          dispatch(updateExploitId(data[0].id));
        }
        dispatch(receiveExploitsSuccess());
      })

      .catch(function() {
        newArtifact.exploits = [];
        dispatch(receiveExploitsError());
      });
  };
};

export const updateRecentVulns = searchResults => {
  return {
    type: UPDATE_RECENT_VULNS,
    searchResults,
  };
};

export const updateFEValidation = validationField => {
  return {
    type: UPDATE_FE_VALIDATION,
    field: validationField.field,
    valid: validationField.valid,
  };
};

export const fetchArtifact = artifactId => {
  return (dispatch, getState) => {
    const endpoint = '/artifacts/components/' + artifactId;

    ApiService.get(endpoint, { shouldUseVeracodeApi: Helpers.isVeracodeUser(getState()) })
      .then(function(data) {
        dispatch(updateArtifact(data));
        const { activeTab, viewMode } = getState().artifactState;

        dispatch(fetchArtifactExploitability(artifactId));
        dispatch(updateArtifactViewMode(viewMode));
        dispatch(updateArtifactActiveTab(activeTab));
        dispatch(updateArtifactActiveArtifact(data));
        dispatch(loadEditedArtifact(data));

        if (
          !ArtifactHelper.isArtifactPremium(data) ||
          PermissionsHelper.isOrgPaidOrTrial(getState())
        ) {
          dispatch(fetchComponents(data.artifactComponents));
        }
        if (PermissionsHelper.isOrgPaidOrTrial(getState())) {
          dispatch(fetchExploits());
        }

        if (data.artifactComponents[0]) {
          dispatch(updateComponentId(data.artifactComponents[0].componentId || null));
        }
      })
      .catch(ex => {
        if (ex.message && ex.message.indexOf('Artifact does not exist') > -1) {
          browserHistory.push(
            `/${MODEL.SOURCECLEAR_COMPONENTS.VULNERABILITY_DATABASE.slug}/search/404`
          );
        }
      });
  };
};

export const fetchArtifactExploitability = (artifactId) => {
  return (dispatch, getState) => {
    const endpoint = '/v3/vulnerabilities/' + artifactId;

    ApiService.get(endpoint, { shouldUseVeracodeApi: Helpers.isVeracodeUser(getState()) })
    .then((data) => {
      dispatch(updateArtifactExploitability(data.exploitability));
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('Failed to retrieve artifact exploitability data: ', error);
    });
  };
};
